import { useQuery } from '@tanstack/react-query';
import Packlink from '@sdk';
import { useFormatCurrency } from '@hooks';

export function useSimulatedPriceByShipment(shipmentId: string, isClientNonSubscribed: boolean) {
    const { data, isLoading } = useQuery({
        queryKey: ['simulatedPrice', shipmentId],
        queryFn: () => Packlink.pro.shipments.price.getSimulated(shipmentId),
        enabled: isClientNonSubscribed,
    });

    return {
        discountedPrice: useFormatCurrency(data?.currency ?? 'EUR', data?.discountedPrice),
        showDiscountedPrice: data?.showDiscountedPrice,
        isLoadingSimulatedPrice: isLoading,
        paidPrice: useFormatCurrency(data?.currency ?? 'EUR', data?.paidPrice),
    };
}
